.hover {
  pointer-events: none;
  opacity: 1;
  position: absolute;
  border: 1px solid #3184fc;
  top: 0;
  left: 0;
}
